import React, { FC } from 'react';
import { GridProps } from '../Grid/types';
import { classes } from './NewGrid.st.css';

export const NewGrid: FC<GridProps> = ({ children }) => {
  return <ul className={classes.gridContainer}>{children}</ul>;
};
